import { useEffect } from "react";

const CONTACT = {
  firstName: "Sumeyra",
  lastName: "Akten",
  name: "Sumeyra Akten",
  company: "Akten Inc.",
  title: "Operations & Compliance Lead",
  phone: "+1 (414) 544-5701",
  phoneRaw: "+14145445701",
  email: "contact@akteninc.com",
  website: "https://www.akteninc.com",
  country: "US",
};

const AKTEN_LOGO_DARK =
  "/site-images/a33bd05564a51120bc11.png";

const AVATAR_URL =
  "/site-images/9e0df259df0ad2f62396.jpg";

function downloadVCF() {
  const vcf = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    `FN:${CONTACT.name}`,
    `N:${CONTACT.lastName};${CONTACT.firstName};;;`,
    `ORG:${CONTACT.company}`,
    `TITLE:${CONTACT.title}`,
    `TEL;TYPE=CELL:${CONTACT.phoneRaw}`,
    `EMAIL;TYPE=INTERNET:${CONTACT.email}`,
    `URL:${CONTACT.website}`,
    `ADR;TYPE=WORK:;;;;;;${CONTACT.country}`,
    "END:VCARD",
  ].join("\r\n");

  const blob = new Blob([vcf], { type: "text/vcard;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  window.location.href = url;
}

export default function SumeyraPage() {
  useEffect(() => {
    document.title = `${CONTACT.name} – ${CONTACT.title} | ${CONTACT.company}`;
  }, []);

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-start">
      {/* Top accent bar */}
      <div className="w-full h-1" style={{ backgroundColor: "#003A5D" }} />

      {/* Card container — mobile-first, max 430px */}
      <div className="w-full max-w-[430px] flex flex-col items-center px-6 pt-10 pb-16">

        {/* Logo */}
        <img
          src={AKTEN_LOGO_DARK}
          alt="AKTEN INC"
          className="h-10 w-auto object-contain mb-10"
        />

        {/* Avatar photo */}
        <div className="w-36 h-36 rounded-full overflow-hidden mb-6">
          <img
            src={AVATAR_URL}
            alt="Sumeyra Akten"
            className="w-full h-full object-cover"
            style={{ objectPosition: "center 15%" }}
          />
        </div>

        {/* Identity */}
        <h1
          className="text-3xl font-semibold tracking-tight mb-1"
          style={{ color: "#2B2B2B", fontFamily: "'Inter', sans-serif" }}
        >
          {CONTACT.name}
        </h1>

        <p
          className="text-sm font-medium uppercase tracking-widest mb-1"
          style={{ color: "#003A5D" }}
        >
          {CONTACT.title}
        </p>

        <p
          className="text-sm font-normal tracking-wide"
          style={{ color: "#7A7A7A" }}
        >
          {CONTACT.company}
        </p>

        {/* Divider */}
        <div className="w-12 h-px mt-8 mb-8" style={{ backgroundColor: "#E0E0E0" }} />

        {/* Save Contact — primary CTA */}
        <button
          onClick={downloadVCF}
          className="w-full flex items-center justify-center gap-3 py-4 rounded-lg text-white text-sm font-semibold tracking-wide transition-opacity hover:opacity-90 active:opacity-80 cursor-pointer whitespace-nowrap"
          style={{ backgroundColor: "#003A5D" }}
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-user-add-line text-base" />
          </span>
          Save Contact
        </button>

        {/* Secondary actions */}
        <div className="w-full grid grid-cols-3 gap-3 mt-4">
          {/* Call */}
          <a
            href={`tel:${CONTACT.phoneRaw}`}
            className="flex flex-col items-center justify-center gap-2 py-4 rounded-lg border transition-colors hover:bg-gray-50 cursor-pointer"
            style={{ borderColor: "#E5E5E5" }}
          >
            <span className="w-6 h-6 flex items-center justify-center" style={{ color: "#003A5D" }}>
              <i className="ri-phone-line text-lg" />
            </span>
            <span className="text-xs font-medium" style={{ color: "#2B2B2B" }}>
              Call
            </span>
          </a>

          {/* Email */}
          <a
            href={`mailto:${CONTACT.email}`}
            className="flex flex-col items-center justify-center gap-2 py-4 rounded-lg border transition-colors hover:bg-gray-50 cursor-pointer"
            style={{ borderColor: "#E5E5E5" }}
          >
            <span className="w-6 h-6 flex items-center justify-center" style={{ color: "#003A5D" }}>
              <i className="ri-mail-line text-lg" />
            </span>
            <span className="text-xs font-medium" style={{ color: "#2B2B2B" }}>
              Email
            </span>
          </a>

          {/* Website */}
          <a
            href={CONTACT.website}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center justify-center gap-2 py-4 rounded-lg border transition-colors hover:bg-gray-50 cursor-pointer"
            style={{ borderColor: "#E5E5E5" }}
          >
            <span className="w-6 h-6 flex items-center justify-center" style={{ color: "#003A5D" }}>
              <i className="ri-global-line text-lg" />
            </span>
            <span className="text-xs font-medium" style={{ color: "#2B2B2B" }}>
              Website
            </span>
          </a>
        </div>

        {/* Contact details */}
        <div className="w-full mt-8 space-y-3">
          <a
            href={`tel:${CONTACT.phoneRaw}`}
            className="w-full flex items-center gap-4 px-4 py-3.5 rounded-lg transition-colors hover:bg-gray-50 cursor-pointer"
            style={{ backgroundColor: "#F8F8F8" }}
          >
            <span className="w-8 h-8 flex items-center justify-center rounded-full" style={{ backgroundColor: "#003A5D1A" }}>
              <i className="ri-phone-line text-sm" style={{ color: "#003A5D" }} />
            </span>
            <div>
              <p className="text-[10px] uppercase tracking-wider font-medium" style={{ color: "#9A9A9A" }}>
                Phone
              </p>
              <p className="text-sm font-medium" style={{ color: "#2B2B2B" }}>
                {CONTACT.phone}
              </p>
            </div>
          </a>

          <a
            href={`mailto:${CONTACT.email}`}
            className="w-full flex items-center gap-4 px-4 py-3.5 rounded-lg transition-colors hover:bg-gray-50 cursor-pointer"
            style={{ backgroundColor: "#F8F8F8" }}
          >
            <span className="w-8 h-8 flex items-center justify-center rounded-full" style={{ backgroundColor: "#003A5D1A" }}>
              <i className="ri-mail-line text-sm" style={{ color: "#003A5D" }} />
            </span>
            <div>
              <p className="text-[10px] uppercase tracking-wider font-medium" style={{ color: "#9A9A9A" }}>
                Email
              </p>
              <p className="text-sm font-medium" style={{ color: "#2B2B2B" }}>
                {CONTACT.email}
              </p>
            </div>
          </a>

          <a
            href={CONTACT.website}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full flex items-center gap-4 px-4 py-3.5 rounded-lg transition-colors hover:bg-gray-50 cursor-pointer"
            style={{ backgroundColor: "#F8F8F8" }}
          >
            <span className="w-8 h-8 flex items-center justify-center rounded-full" style={{ backgroundColor: "#003A5D1A" }}>
              <i className="ri-global-line text-sm" style={{ color: "#003A5D" }} />
            </span>
            <div>
              <p className="text-[10px] uppercase tracking-wider font-medium" style={{ color: "#9A9A9A" }}>
                Website
              </p>
              <p className="text-sm font-medium" style={{ color: "#2B2B2B" }}>
                akteninc.com
              </p>
            </div>
          </a>
        </div>

        {/* Footer */}
        <p className="mt-12 text-[11px] tracking-wide text-center" style={{ color: "#C0C0C0" }}>
          AKTEN INC &copy; {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
}
